/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tags_ProjectilesInputs */

const en_control_tags_projectiles = /** @type {(inputs: Control_Tags_ProjectilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projectiles`)
};

const zh_control_tags_projectiles = /** @type {(inputs: Control_Tags_ProjectilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`远程投射`)
};

/**
* | output |
* | --- |
* | "Projectiles" |
*
* @param {Control_Tags_ProjectilesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tags_projectiles = /** @type {((inputs?: Control_Tags_ProjectilesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tags_ProjectilesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tags_projectiles(inputs)
	return zh_control_tags_projectiles(inputs)
});
export { control_tags_projectiles as "control.tags.projectiles" }